import React from 'react';

// Canonical segmented pill control (matches the Reports PERIOD pills).
// One reusable component for every filter/segment pill across the app.
// Options: { id, label, testId, count?, badge?, badgeTone? }
export const Segmented = ({ options, value, onChange, testId, className = '' }) => (
  <div className={`inline-flex items-center gap-0 bg-[#F2F0EA] border border-[#E2DED4] p-[2px] flex-wrap ${className}`} style={{ borderRadius: 6 }} data-testid={testId}>
    {options.map((o) => {
      const active = value === o.id;
      return (
        <button
          key={o.id}
          type="button"
          onClick={() => onChange(o.id)}
          data-testid={o.testId}
          style={{ borderRadius: 4 }}
          className={`h-7 px-[11px] text-[13px] transition-colors inline-flex items-center gap-1.5 ${active ? 'bg-[#FFD108] text-black font-bold shadow-sm' : 'text-[#6B6660] font-medium hover:text-[#1A1A1A]'}`}
        >
          {o.label}
          {o.count != null && <span className={`font-mono text-[10px] ${active ? 'text-black/70' : 'text-[#8F8A7F]'}`}>{o.count}</span>}
          {o.badge != null && o.badge > 0 && (
            <span
              className="font-mono text-[10px] font-bold rounded-[4px] px-[5px] py-[1px]"
              style={o.badgeTone === 'danger' ? { color: '#B91C1C', background: '#FEF2F2' } : { color: '#8A6D00', background: '#FFF8D6' }}
            >
              {o.badge}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default Segmented;
